// extracted by mini-css-extract-plugin
export default {"component":"chapter-detail__mBqwg"};